import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import React from 'react';
import styles from '../SplashCta.less';
import Block from '../../../../block/Block';
import { renderCmsComponent } from '../../../utils';
import SplashLink from './SplashLink';

function MobileSplashCta(_ref) {
  var _ref$splashCTAButtons = _ref.splashCTAButtons,
      splashCTAButtons = _ref$splashCTAButtons === void 0 ? [] : _ref$splashCTAButtons,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? [] : _ref$content;
  var sortedSplashButtons = splashCTAButtons && splashCTAButtons.reduce(function (acc, item) {
    acc["primary_".concat(item.primary)] = acc["primary_".concat(item.primary)] || [];
    acc["primary_".concat(item.primary)].push(item);
    return acc;
  }, {});
  var primaryButtons = sortedSplashButtons && sortedSplashButtons['primary_true'];
  var secondaryButtons = sortedSplashButtons && sortedSplashButtons['primary_false'];
  var includeData = content && content.filter(function (item) {
    return item && item.component && item.component.schema && item.component.schema === 'Include';
  });
  return /*#__PURE__*/React.createElement(Block, {
    layout: true,
    vertical: true,
    center: true
  }, includeData && Array.isArray(includeData) && includeData.length ? includeData.map(function (component, index) {
    return renderCmsComponent(component, index);
  }) : null, primaryButtons && Array.isArray(primaryButtons) && primaryButtons.length ? /*#__PURE__*/React.createElement("div", {
    className: styles['primary-true']
  }, primaryButtons.map(function (_ref2, index) {
    var title = _ref2.title,
        splashUrl = _ref2.splash_link,
        primary = _ref2.primary;
    return /*#__PURE__*/React.createElement(SplashLink, {
      key: index,
      title: title,
      splashUrl: splashUrl,
      primary: primary
    });
  })) : null, secondaryButtons && Array.isArray(secondaryButtons) && secondaryButtons.length ? /*#__PURE__*/React.createElement(Block, {
    layout: true,
    className: "".concat(styles['primary-false'], " ").concat(secondaryButtons.length === 1 && styles['no-border-right'])
  }, secondaryButtons.map(function (_ref3, index) {
    var title = _ref3.title,
        splashUrl = _ref3.splash_link,
        primary = _ref3.primary;
    return /*#__PURE__*/React.createElement(SplashLink, {
      key: index,
      title: title,
      splashUrl: splashUrl,
      primary: primary
    });
  })) : null);
}

export default MobileSplashCta;